import { render, staticRenderFns } from "./MonthlyReport.vue?vue&type=template&id=2354c46c&"
import script from "./MonthlyReport.vue?vue&type=script&lang=js&"
export * from "./MonthlyReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports